module.exports = __webpack_public_path__ + "img/MES10Indice1_cutout.9dd45d4c.png";